import React, { FC } from 'react'

import { Txt, DecorationTitle, Card } from 'src/components/atoms'
import { PasswordAuthToggle } from 'src/components/molecules'

import { useGetCompany } from 'src/hooks'

type Props = {
  className?: string
}

export const PasswordAuthSetting: FC<Props> = ({ className }) => {
  const { loading, company, refetch } = useGetCompany()

  const handleAfterTogglePasswordAuthSettings = async () => {
    await refetch()
  }

  return (
    <div className={className}>
      <Card padding="--s1">
        <div className="tw-full-justify">
          <DecorationTitle sizeType="l">パスワード認証</DecorationTitle>
          {!loading && company && (
            <div className="tw-flex tw-justify-end">
              <PasswordAuthToggle
                company={company}
                afterUpdate={handleAfterTogglePasswordAuthSettings}
              />
            </div>
          )}
        </div>

        <div>
          <div className="tw-text-standardText-secondary tw-mt-s1">
            <Txt>メールアドレスとパスワード入力してログインする一般的なログイン方式です。</Txt>
          </div>
        </div>
      </Card>
    </div>
  )
}
